import { AuthenticationService } from "./authentication.service";

export const authenticationServiceInstance = new AuthenticationService();
